import classNames from 'classnames';
const CanalFact = ({
    subHeading,
    heading,
    image,
    blockProps = {
        className: {}
    },
    children
}) => {

    const { className } = blockProps;
    
    return (
        <section {...blockProps}>
            <div className={classNames({
                'canal-fact__columns': true,
                'canal-fact__columns--has-image': image
            })}>
                {image &&
                    <figure className="canal-fact__image">
                        <img src={image.src} alt={image.alt} />
                    </figure>
                }
                <div>
                    {subHeading}
                    {heading}
                </div>
            </div>
            
            {children}
            
        </section>
    );
};

export default CanalFact;